import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { login }  from '../../../store/auth';
import { useAuth } from './AuthContext';
import {
  CustomInput,
  CustomPasswordInput,
  CustomSubmitButton,
  CustomAlert,
  CustomModalHeader,
  CustomLinkButton,
  CustomFormStyles
} from './CustomFormComponents';

const Singin = ({ show, handleClose, switchToSignUp, switchToForgotPassword, onLoginSuccess }) => {
  const { login: authContextLogin } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
    if (errors.general) {
      setErrors(prev => ({ ...prev, general: '' }));
    }
    if (successMessage) {
      setSuccessMessage('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!validateForm()) {
    return;
  }

  setIsLoading(true);
  setErrors({});
  setSuccessMessage('');
  
  try {
    const response = await login({
      email: formData.email,
      password: formData.password
    });
    
    
    const token = response.token || response.data?.token || response.authToken || response.data?.authToken;
    const refreshToken = response.refreshToken || response.data?.refreshToken;
    const userData = response.user || response.data?.user || {
      name: formData.email.split('@')[0],
      email: formData.email,
      id: response.id || response.data?.id,
      is_admin: response.is_admin || response.data?.is_admin || false
    };


    // Use AuthContext login function to update global state
    authContextLogin(userData, token, refreshToken);
    
    const message = response.message || response.data?.message || 'Sign in successful!';
    setSuccessMessage(message);
    
    if (onLoginSuccess) {
      onLoginSuccess({
        data: {
          user: userData,
          token: token
        }
      });
    }
    
    // Close modal after showing success message (give user time to read it)
    setTimeout(() => {
      setFormData({ email: '', password: '' });
      setSuccessMessage('');
      handleClose();
    }, 2000);
    
  } catch (error) {
    // Don't close modal on error - let user see the error message and try again
    console.error('Login error:', error);
    setErrors({ general: error.message || 'Sign in failed. Please try again.' });
    // if (error.status === 401) {
    //   setErrors({ general: 'Invalid email or password. Please try again.' });
    // } else if (error.status === 404) {
    //   setErrors({ general: 'User not found. Please check your email address.' });
    // } else if (error.status === 403) {
    //   setErrors({ general: 'Access forbidden. Please check your credentials.' });
    // } else {
    //   setErrors({ general: error.message || 'Sign in failed. Please try again.' });
    // }
  } finally {
    setIsLoading(false);
  }
};
  const handleModalClose = () => {
    setFormData({ email: '', password: '' });
    setErrors({});
    setSuccessMessage('');
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleModalClose} centered backdrop="static" keyboard={false}>
        <CustomModalHeader 
          title="Sign in" 
          onClose={handleModalClose} 
        />
        
        <Modal.Body className="px-4 pb-4">
          <CustomAlert 
            type="success" 
            message={successMessage} 
            show={!!successMessage} 
          />
          
          <CustomAlert 
            type="danger" 
            message={errors.general} 
            show={!!errors.general} 
          />
          
          <form onSubmit={handleSubmit}>
            <CustomInput
              type="email"
              name="email"
              label="Email"
              required
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              error={errors.email}
              disabled={isLoading}
            />

            <CustomPasswordInput
              name="password"
              label="Password"
              required
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Password"
              error={errors.password}
              disabled={isLoading}
              showPassword={showPassword}
              onTogglePassword={() => setShowPassword(!showPassword)}
            />

            <CustomSubmitButton
              isLoading={isLoading}
              loadingText="Logging in..."
            >
              Sign in
            </CustomSubmitButton>
          </form>

          <div className="text-center">
            <p className="mb-2" style={{ color: '#000' }}>
              Don't have an account?{' '}
              <CustomLinkButton onClick={switchToSignUp} disabled={isLoading}
              className="inline align-baseline">
                Sign Up
              </CustomLinkButton>
            </p>
            <p className="mb-0" style={{ color: '#000' }}>
              <CustomLinkButton 
                onClick={switchToForgotPassword} 
                disabled={isLoading}
                className="fw-normal"
              >
                Forgot password?
              </CustomLinkButton>
            </p>
          </div>
        </Modal.Body>
      </Modal>

      <CustomFormStyles />
    </>
  );
};

export default Singin;